'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Tool tips can be used to include some additional explanatory text about another element.
 * Default positioning is on top, and visibility is hidden. Add the .is-active class to
 * ToolTip-content to make the tooltip visible.
 * Width is static, height and positioning are dynamic relative to the element with the ToolTip class.
 *
 * @extends {React.Compponent}
 * @property {String} tooltip Tooltip message to display.
 * @property {String} position (Optional) Sets the tooltip position. If not included,
 *                             the tooltip is rendered top.
 */
class Tooltip extends React.Component {
  /**
   * Default constructor.
   * @constructor
   */
  constructor (props) {
    super(props);
    this.state = {
      isActive: false
    };
  }

  /**
   * Handles the component behaviour on hover.
   */
  _handleTooltipShow () {
    this.setState({isActive: !this.state.isActive});
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const classes = classNames({
      'ToolTip-content': true,
      [`ToolTip-content--${this.props.position}`]: this.props.position,
      'is-active': this.state.isActive
    });

    return (
      <span className='ToolTip'>
        <div className={classes}>{this.props.tooltip}</div>
        <div
          onClick={this._handleTooltipShow.bind(this)}
          >
          {this.props.children}
        </div>
      </span>
    );
  }
}

Tooltip.defaultProps = {
};

Tooltip.propTypes = {
  tooltip: React.PropTypes.string.isRequired,
  position: React.PropTypes.oneOf([
    'top', 'bottom', 'left', 'right'
  ])
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/tooltip.jsx